import { render, staticRenderFns } from "./ProjectsAdmin.vue?vue&type=template&id=206146dc&"
import script from "./ProjectsAdmin.vue?vue&type=script&lang=js&"
export * from "./ProjectsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports